function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function t() {
  return (t = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function e(t) {
  if ("undefined" != typeof window && window.navigator) return !!navigator.userAgent.match(t);
}

var n = e(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i),
    o = e(/Edge/i),
    i = e(/firefox/i),
    r = e(/safari/i) && !e(/chrome/i) && !e(/android/i),
    a = e(/iP(ad|od|hone)/i),
    l = e(/chrome/i) && e(/android/i),
    s = {
  capture: !1,
  passive: !1
};

function c(t, e, o) {
  t.addEventListener(e, o, !n && s);
}

function u(t, e, o) {
  t.removeEventListener(e, o, !n && s);
}

function d(t, e) {
  if (e) {
    if (">" === e[0] && (e = e.substring(1)), t) try {
      if (t.matches) return t.matches(e);
      if (t.msMatchesSelector) return t.msMatchesSelector(e);
      if (t.webkitMatchesSelector) return t.webkitMatchesSelector(e);
    } catch (t) {
      return !1;
    }
    return !1;
  }
}

function h(t) {
  return t.host && t !== document && t.host.nodeType ? t.host : t.parentNode;
}

function f(t, e, n, o) {
  if (t) {
    n = n || document;

    do {
      if (null != e && (">" === e[0] ? t.parentNode === n && d(t, e) : d(t, e)) || o && t === n) return t;
      if (t === n) break;
    } while (t = h(t));
  }

  return null;
}

var p,
    g = /\s+/g;

function v(t, e, n) {
  if (t && e) if (t.classList) t.classList[n ? "add" : "remove"](e);else {
    var o = (" " + t.className + " ").replace(g, " ").replace(" " + e + " ", " ");
    t.className = (o + (n ? " " + e : "")).replace(g, " ");
  }
}

function m(t, e, n) {
  var o = t && t.style;

  if (o) {
    if (void 0 === n) return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(t, "") : t.currentStyle && (n = t.currentStyle), void 0 === e ? n : n[e];
    e in o || -1 !== e.indexOf("webkit") || (e = "-webkit-" + e), o[e] = n + ("string" == typeof n ? "" : "px");
  }
}

function b(t, e) {
  var n = "";
  if ("string" == typeof t) n = t;else do {
    var o = m(t, "transform");
    o && "none" !== o && (n = o + " " + n);
  } while (!e && (t = t.parentNode));
  var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return i && new i(n);
}

function w(t, e, n) {
  if (t) {
    var o = t.getElementsByTagName(e),
        i = 0,
        r = o.length;
    if (n) for (; i < r; i++) {
      n(o[i], i);
    }
    return o;
  }

  return [];
}

function E() {
  return document.scrollingElement || document.documentElement;
}

function y(t, e, o, i, r) {
  if (t.getBoundingClientRect || t === window) {
    var a, l, s, c, u, d, h;
    if (t !== window && t !== E() ? (l = (a = t.getBoundingClientRect()).top, s = a.left, c = a.bottom, u = a.right, d = a.height, h = a.width) : (l = 0, s = 0, c = window.innerHeight, u = window.innerWidth, d = window.innerHeight, h = window.innerWidth), (e || o) && t !== window && (r = r || t.parentNode, !n)) do {
      if (r && r.getBoundingClientRect && ("none" !== m(r, "transform") || o && "static" !== m(r, "position"))) {
        var f = r.getBoundingClientRect();
        l -= f.top + parseInt(m(r, "border-top-width")), s -= f.left + parseInt(m(r, "border-left-width")), c = l + a.height, u = s + a.width;
        break;
      }
    } while (r = r.parentNode);

    if (i && t !== window) {
      var p = b(r || t),
          g = p && p.a,
          v = p && p.d;
      p && (c = (l /= v) + (d /= v), u = (s /= g) + (h /= g));
    }

    return {
      top: l,
      left: s,
      bottom: c,
      right: u,
      width: h,
      height: d
    };
  }
}

function D(t, e, n) {
  for (var o = x(t, !0), i = y(t)[e]; o;) {
    var r = y(o)[n];
    if (!("top" === n || "left" === n ? i >= r : i <= r)) return o;
    if (o === E()) break;
    o = x(o, !1);
  }

  return !1;
}

function _(t, e, n) {
  for (var o = 0, i = 0, r = t.children; i < r.length;) {
    if ("none" !== r[i].style.display && r[i] !== It.ghost && r[i] !== It.dragged && f(r[i], n.draggable, t, !1)) {
      if (o === e) return r[i];
      o++;
    }

    i++;
  }

  return null;
}

function S(t, e) {
  for (var n = t.lastElementChild; n && (n === It.ghost || "none" === m(n, "display") || e && !d(n, e));) {
    n = n.previousElementSibling;
  }

  return n || null;
}

function C(t, e) {
  var n = 0;
  if (!t || !t.parentNode) return -1;

  for (; t = t.previousElementSibling;) {
    "TEMPLATE" === t.nodeName.toUpperCase() || t === It.clone || e && !d(t, e) || n++;
  }

  return n;
}

function T(t) {
  var e = 0,
      n = 0,
      o = E();
  if (t) do {
    var i = b(t);
    e += t.scrollLeft * i.a, n += t.scrollTop * i.d;
  } while (t !== o && (t = t.parentNode));
  return [e, n];
}

function x(t, e) {
  if (!t || !t.getBoundingClientRect) return E();
  var n = t,
      o = !1;

  do {
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var i = m(n);

      if (n.clientWidth < n.scrollWidth && ("auto" == i.overflowX || "scroll" == i.overflowX) || n.clientHeight < n.scrollHeight && ("auto" == i.overflowY || "scroll" == i.overflowY)) {
        if (!n.getBoundingClientRect || n === document.body) return E();
        if (o || e) return n;
        o = !0;
      }
    }
  } while (n = n.parentNode);

  return E();
}

function M(t, e) {
  return Math.round(t.top) === Math.round(e.top) && Math.round(t.left) === Math.round(e.left) && Math.round(t.height) === Math.round(e.height) && Math.round(t.width) === Math.round(e.width);
}

function N(t, e) {
  return function () {
    if (!p) {
      var n = arguments,
          o = this;
      1 === n.length ? t.call(o, n[0]) : t.apply(o, n), p = setTimeout(function () {
        p = void 0;
      }, e);
    }
  };
}

function O(t, e, n) {
  t.scrollLeft += e, t.scrollTop += n;
}

function A(t) {
  var e = window.Polymer,
      n = window.jQuery || window.Zepto;
  return e && e.dom ? e.dom(t).cloneNode(!0) : n ? n(t).clone(!0)[0] : t.cloneNode(!0);
}

function I(t, e) {
  m(t, "position", "absolute"), m(t, "top", e.top), m(t, "left", e.left), m(t, "width", e.width), m(t, "height", e.height);
}

function P(t) {
  m(t, "position", ""), m(t, "top", ""), m(t, "left", ""), m(t, "width", ""), m(t, "height", "");
}

var k = "Sortable" + new Date().getTime(),
    R = [],
    X = {
  initializeByDefault: !0
},
    Y = {
  mount: function mount(t) {
    for (var e in X) {
      X.hasOwnProperty(e) && !(e in t) && (t[e] = X[e]);
    }

    R.push(t);
  },
  pluginEvent: function pluginEvent(e, n, o) {
    var i = this;
    this.eventCanceled = !1, o.cancel = function () {
      i.eventCanceled = !0;
    };
    var r = e + "Global";
    R.forEach(function (i) {
      n[i.pluginName] && (n[i.pluginName][r] && n[i.pluginName][r](t({
        sortable: n
      }, o)), n.options[i.pluginName] && n[i.pluginName][e] && n[i.pluginName][e](t({
        sortable: n
      }, o)));
    });
  },
  initializePlugins: function initializePlugins(t, e, n, o) {
    for (var i in R.forEach(function (o) {
      var i = o.pluginName;

      if (t.options[i] || o.initializeByDefault) {
        var r = new o(t, e, t.options);
        r.sortable = t, r.options = t.options, t[i] = r, Object.assign(n, r.defaults);
      }
    }), t.options) {
      if (t.options.hasOwnProperty(i)) {
        var r = this.modifyOption(t, i, t.options[i]);
        void 0 !== r && (t.options[i] = r);
      }
    }
  },
  getEventProperties: function getEventProperties(t, e) {
    var n = {};
    return R.forEach(function (o) {
      "function" == typeof o.eventProperties && Object.assign(n, o.eventProperties.call(e[o.pluginName], t));
    }), n;
  },
  modifyOption: function modifyOption(t, e, n) {
    var o;
    return R.forEach(function (i) {
      t[i.pluginName] && i.optionListeners && "function" == typeof i.optionListeners[e] && (o = i.optionListeners[e].call(t[i.pluginName], n));
    }), o;
  }
};

function B(e) {
  var i = e.sortable,
      r = e.rootEl,
      a = e.name,
      l = e.targetEl,
      s = e.cloneEl,
      c = e.toEl,
      u = e.fromEl,
      d = e.oldIndex,
      h = e.newIndex,
      f = e.oldDraggableIndex,
      p = e.newDraggableIndex,
      g = e.originalEvent,
      v = e.putSortable,
      m = e.extraEventProperties;

  if (i = i || r && r[k]) {
    var b,
        w = i.options,
        E = "on" + a.charAt(0).toUpperCase() + a.substr(1);
    !window.CustomEvent || n || o ? (b = document.createEvent("Event")).initEvent(a, !0, !0) : b = new CustomEvent(a, {
      bubbles: !0,
      cancelable: !0
    }), b.to = c || r, b.from = u || r, b.item = l || r, b.clone = s, b.oldIndex = d, b.newIndex = h, b.oldDraggableIndex = f, b.newDraggableIndex = p, b.originalEvent = g, b.pullMode = v ? v.lastPutMode : void 0;
    var y = t({}, m, Y.getEventProperties(a, i));

    for (var D in y) {
      b[D] = y[D];
    }

    r && r.dispatchEvent(b), w[E] && w[E].call(i, b);
  }
}

var H = function H(e, n, o) {
  var i = void 0 === o ? {} : o,
      r = i.evt,
      a = function (t, e) {
    if (null == t) return {};
    var n,
        o,
        i = {},
        r = Object.keys(t);

    for (o = 0; o < r.length; o++) {
      e.indexOf(n = r[o]) >= 0 || (i[n] = t[n]);
    }

    return i;
  }(i, ["evt"]);

  Y.pluginEvent.bind(It)(e, n, t({
    dragEl: L,
    parentEl: K,
    ghostEl: W,
    rootEl: j,
    nextEl: z,
    lastDownEl: G,
    cloneEl: U,
    cloneHidden: q,
    dragStarted: lt,
    putSortable: tt,
    activeSortable: It.active,
    originalEvent: r,
    oldIndex: V,
    oldDraggableIndex: Q,
    newIndex: Z,
    newDraggableIndex: $,
    hideGhostForTarget: xt,
    unhideGhostForTarget: Mt,
    cloneNowHidden: function cloneNowHidden() {
      q = !0;
    },
    cloneNowShown: function cloneNowShown() {
      q = !1;
    },
    dispatchSortableEvent: function dispatchSortableEvent(t) {
      F({
        sortable: n,
        name: t,
        originalEvent: r
      });
    }
  }, a));
};

function F(e) {
  B(t({
    putSortable: tt,
    cloneEl: U,
    targetEl: L,
    rootEl: j,
    oldIndex: V,
    oldDraggableIndex: Q,
    newIndex: Z,
    newDraggableIndex: $
  }, e));
}

var L,
    K,
    W,
    j,
    z,
    G,
    U,
    q,
    V,
    Z,
    Q,
    $,
    J,
    tt,
    et,
    nt,
    ot,
    it,
    rt,
    at,
    lt,
    st,
    ct,
    ut,
    dt,
    ht = !1,
    ft = !1,
    pt = [],
    gt = !1,
    vt = !1,
    mt = [],
    bt = !1,
    wt = [],
    Et = "undefined" != typeof document,
    yt = a,
    Dt = o || n ? "cssFloat" : "float",
    _t = Et && !l && !a && "draggable" in document.createElement("div"),
    St = function () {
  if (Et) {
    if (n) return !1;
    var t = document.createElement("x");
    return t.style.cssText = "pointer-events:auto", "auto" === t.style.pointerEvents;
  }
}(),
    Ct = function Ct(t, e) {
  var n = m(t),
      o = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth),
      i = _(t, 0, e),
      r = _(t, 1, e),
      a = i && m(i),
      l = r && m(r),
      s = a && parseInt(a.marginLeft) + parseInt(a.marginRight) + y(i).width,
      c = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + y(r).width;

  return "flex" === n.display ? "column" === n.flexDirection || "column-reverse" === n.flexDirection ? "vertical" : "horizontal" : "grid" === n.display ? n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal" : i && a.float && "none" !== a.float ? !r || "both" !== l.clear && l.clear !== ("left" === a.float ? "left" : "right") ? "horizontal" : "vertical" : i && ("block" === a.display || "flex" === a.display || "table" === a.display || "grid" === a.display || s >= o && "none" === n[Dt] || r && "none" === n[Dt] && s + c > o) ? "vertical" : "horizontal";
},
    Tt = function Tt(t) {
  function e(t, n) {
    return function (o, i, r, a) {
      if (null == t && (n || o.options.group.name && i.options.group.name && o.options.group.name === i.options.group.name)) return !0;
      if (null == t || !1 === t) return !1;
      if (n && "clone" === t) return t;
      if ("function" == typeof t) return e(t(o, i, r, a), n)(o, i, r, a);
      var l = (n ? o : i).options.group.name;
      return !0 === t || "string" == typeof t && t === l || t.join && t.indexOf(l) > -1;
    };
  }

  var n = {},
      o = t.group;
  o && "object" == _typeof(o) || (o = {
    name: o
  }), n.name = o.name, n.checkPull = e(o.pull, !0), n.checkPut = e(o.put), n.revertClone = o.revertClone, t.group = n;
},
    xt = function xt() {
  !St && W && m(W, "display", "none");
},
    Mt = function Mt() {
  !St && W && m(W, "display", "");
};

Et && document.addEventListener("click", function (t) {
  if (ft) return t.preventDefault(), t.stopPropagation && t.stopPropagation(), t.stopImmediatePropagation && t.stopImmediatePropagation(), ft = !1, !1;
}, !0);

var Nt,
    Ot = function Ot(t) {
  if (L) {
    var e = (i = (t = t.touches ? t.touches[0] : t).clientX, r = t.clientY, pt.some(function (t) {
      if (!S(t)) {
        var e = y(t),
            n = t[k].options.emptyInsertThreshold;
        return n && i >= e.left - n && i <= e.right + n && r >= e.top - n && r <= e.bottom + n ? a = t : void 0;
      }
    }), a);

    if (e) {
      var n = {};

      for (var o in t) {
        t.hasOwnProperty(o) && (n[o] = t[o]);
      }

      n.target = n.rootEl = e, n.preventDefault = void 0, n.stopPropagation = void 0, e[k]._onDragOver(n);
    }
  }

  var i, r, a;
},
    At = function At(t) {
  L && L.parentNode[k]._isOutsideThisEl(t.target);
};

function It(e, n) {
  if (!e || !e.nodeType || 1 !== e.nodeType) throw "Sortable: `el` must be an HTMLElement, not " + {}.toString.call(e);
  this.el = e, this.options = n = Object.assign({}, n), e[k] = this;
  var o,
      i,
      r = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: !1,
    invertedSwapThreshold: null,
    removeCloneOnHide: !0,
    direction: function direction() {
      return Ct(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function setData(t, e) {
      t.setData("Text", e.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: !1 !== It.supportPointer && "PointerEvent" in window,
    emptyInsertThreshold: 5
  };

  for (var a in Y.initializePlugins(this, e, r), r) {
    !(a in n) && (n[a] = r[a]);
  }

  for (var l in Tt(n), this) {
    "_" === l.charAt(0) && "function" == typeof this[l] && (this[l] = this[l].bind(this));
  }

  this.nativeDraggable = !n.forceFallback && _t, this.nativeDraggable && (this.options.touchStartThreshold = 1), n.supportPointer ? c(e, "pointerdown", this._onTapStart) : (c(e, "mousedown", this._onTapStart), c(e, "touchstart", this._onTapStart)), this.nativeDraggable && (c(e, "dragover", this), c(e, "dragenter", this)), pt.push(this.el), n.store && n.store.get && this.sort(n.store.get(this) || []), Object.assign(this, (i = [], {
    captureAnimationState: function captureAnimationState() {
      i = [], this.options.animation && [].slice.call(this.el.children).forEach(function (e) {
        if ("none" !== m(e, "display") && void 0 !== e) {
          i.push({
            target: e,
            rect: y(e)
          });
          var n = t({}, i[i.length - 1].rect);

          if (e.thisAnimationDuration) {
            var o = b(e, !0);
            o && (n.top -= o.f, n.left -= o.e);
          }

          e.fromRect = n;
        }
      });
    },
    addAnimationState: function addAnimationState(t) {
      i.push(t);
    },
    removeAnimationState: function removeAnimationState(t) {
      i.splice(function (t, e) {
        for (var n in t) {
          if (t.hasOwnProperty(n)) for (var o in e) {
            if (e.hasOwnProperty(o) && e[o] === t[n][o]) return Number(n);
          }
        }

        return -1;
      }(i, {
        target: t
      }), 1);
    },
    animateAll: function animateAll(t) {
      var e = this;
      if (!this.options.animation) return clearTimeout(o), void ("function" == typeof t && t());
      var n = !1,
          r = 0;
      i.forEach(function (t) {
        var o = 0,
            i = t.target,
            a = i.fromRect,
            l = y(i),
            s = i.prevFromRect,
            c = i.prevToRect,
            u = t.rect,
            d = b(i, !0);
        d && (l.top -= d.f, l.left -= d.e), i.toRect = l, i.thisAnimationDuration && M(s, l) && !M(a, l) && (u.top - l.top) / (u.left - l.left) == (a.top - l.top) / (a.left - l.left) && (o = function (t, e, n, o) {
          return Math.sqrt(Math.pow(e.top - t.top, 2) + Math.pow(e.left - t.left, 2)) / Math.sqrt(Math.pow(e.top - n.top, 2) + Math.pow(e.left - n.left, 2)) * o.animation;
        }(u, s, c, e.options)), M(l, a) || (i.prevFromRect = a, i.prevToRect = l, o || (o = e.options.animation), e.animate(i, u, l, o)), o && (n = !0, r = Math.max(r, o), clearTimeout(i.animationResetTimer), i.animationResetTimer = setTimeout(function () {
          i.animationTime = 0, i.prevFromRect = null, i.fromRect = null, i.prevToRect = null, i.thisAnimationDuration = null;
        }, o), i.thisAnimationDuration = o);
      }), clearTimeout(o), n ? o = setTimeout(function () {
        "function" == typeof t && t();
      }, r) : "function" == typeof t && t(), i = [];
    },
    animate: function animate(t, e, n, o) {
      if (o) {
        m(t, "transition", ""), m(t, "transform", "");
        var i = b(this.el),
            r = (e.left - n.left) / (i && i.a || 1),
            a = (e.top - n.top) / (i && i.d || 1);
        t.animatingX = !!r, t.animatingY = !!a, m(t, "transform", "translate3d(" + r + "px," + a + "px,0)"), this.forRepaintDummy = function (t) {
          return t.offsetWidth;
        }(t), m(t, "transition", "transform " + o + "ms" + (this.options.easing ? " " + this.options.easing : "")), m(t, "transform", "translate3d(0,0,0)"), "number" == typeof t.animated && clearTimeout(t.animated), t.animated = setTimeout(function () {
          m(t, "transition", ""), m(t, "transform", ""), t.animated = !1, t.animatingX = !1, t.animatingY = !1;
        }, o);
      }
    }
  }));
}

function Pt(t, e, i, r, a, l, s, c) {
  var u,
      d,
      h = t[k],
      f = h.options.onMove;
  return !window.CustomEvent || n || o ? (u = document.createEvent("Event")).initEvent("move", !0, !0) : u = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }), u.to = e, u.from = t, u.dragged = i, u.draggedRect = r, u.related = a || e, u.relatedRect = l || y(e), u.willInsertAfter = c, u.originalEvent = s, t.dispatchEvent(u), f && (d = f.call(h, u, s)), d;
}

function kt(t) {
  t.draggable = !1;
}

function Rt() {
  bt = !1;
}

function Xt(t) {
  for (var e = t.tagName + t.className + t.src + t.href + t.textContent, n = e.length, o = 0; n--;) {
    o += e.charCodeAt(n);
  }

  return o.toString(36);
}

function Yt(t) {
  return setTimeout(t, 0);
}

function Bt(t) {
  return clearTimeout(t);
}

It.prototype = {
  constructor: It,
  _isOutsideThisEl: function _isOutsideThisEl(t) {
    this.el.contains(t) || t === this.el || (st = null);
  },
  _getDirection: function _getDirection(t, e) {
    return "function" == typeof this.options.direction ? this.options.direction.call(this, t, e, L) : this.options.direction;
  },
  _onTapStart: function _onTapStart(t) {
    if (t.cancelable) {
      var e = this,
          n = this.el,
          o = this.options,
          i = o.preventOnFilter,
          a = t.type,
          l = t.touches && t.touches[0] || t.pointerType && "touch" === t.pointerType && t,
          s = (l || t).target,
          c = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || s,
          u = o.filter;

      if (function (t) {
        wt.length = 0;

        for (var e = t.getElementsByTagName("input"), n = e.length; n--;) {
          var o = e[n];
          o.checked && wt.push(o);
        }
      }(n), !L && !(/mousedown|pointerdown/.test(a) && 0 !== t.button || o.disabled) && !c.isContentEditable && (this.nativeDraggable || !r || !s || "SELECT" !== s.tagName.toUpperCase()) && !((s = f(s, o.draggable, n, !1)) && s.animated || G === s)) {
        if (V = C(s), Q = C(s, o.draggable), "function" == typeof u) {
          if (u.call(this, t, s, this)) return F({
            sortable: e,
            rootEl: c,
            name: "filter",
            targetEl: s,
            toEl: n,
            fromEl: n
          }), H("filter", e, {
            evt: t
          }), void (i && t.cancelable && t.preventDefault());
        } else if (u && (u = u.split(",").some(function (o) {
          if (o = f(c, o.trim(), n, !1)) return F({
            sortable: e,
            rootEl: o,
            name: "filter",
            targetEl: s,
            fromEl: n,
            toEl: n
          }), H("filter", e, {
            evt: t
          }), !0;
        }))) return void (i && t.cancelable && t.preventDefault());

        o.handle && !f(c, o.handle, n, !1) || this._prepareDragStart(t, l, s);
      }
    }
  },
  _prepareDragStart: function _prepareDragStart(t, e, r) {
    var a,
        l = this,
        s = l.el,
        u = l.options,
        d = s.ownerDocument;

    if (r && !L && r.parentNode === s) {
      var h = y(r);
      if (j = s, K = (L = r).parentNode, z = L.nextSibling, G = r, J = u.group, It.dragged = L, rt = (et = {
        target: L,
        clientX: (e || t).clientX,
        clientY: (e || t).clientY
      }).clientX - h.left, at = et.clientY - h.top, this._lastX = (e || t).clientX, this._lastY = (e || t).clientY, L.style["will-change"] = "all", a = function a() {
        H("delayEnded", l, {
          evt: t
        }), It.eventCanceled ? l._onDrop() : (l._disableDelayedDragEvents(), !i && l.nativeDraggable && (L.draggable = !0), l._triggerDragStart(t, e), F({
          sortable: l,
          name: "choose",
          originalEvent: t
        }), v(L, u.chosenClass, !0));
      }, u.ignore.split(",").forEach(function (t) {
        w(L, t.trim(), kt);
      }), c(d, "dragover", Ot), c(d, "mousemove", Ot), c(d, "touchmove", Ot), c(d, "mouseup", l._onDrop), c(d, "touchend", l._onDrop), c(d, "touchcancel", l._onDrop), i && this.nativeDraggable && (this.options.touchStartThreshold = 4, L.draggable = !0), H("delayStart", this, {
        evt: t
      }), !u.delay || u.delayOnTouchOnly && !e || this.nativeDraggable && (o || n)) a();else {
        if (It.eventCanceled) return void this._onDrop();
        c(d, "mouseup", l._disableDelayedDrag), c(d, "touchend", l._disableDelayedDrag), c(d, "touchcancel", l._disableDelayedDrag), c(d, "mousemove", l._delayedDragTouchMoveHandler), c(d, "touchmove", l._delayedDragTouchMoveHandler), u.supportPointer && c(d, "pointermove", l._delayedDragTouchMoveHandler), l._dragStartTimer = setTimeout(a, u.delay);
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(t) {
    var e = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(e.clientX - this._lastX), Math.abs(e.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    L && kt(L), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var t = this.el.ownerDocument;
    u(t, "mouseup", this._disableDelayedDrag), u(t, "touchend", this._disableDelayedDrag), u(t, "touchcancel", this._disableDelayedDrag), u(t, "mousemove", this._delayedDragTouchMoveHandler), u(t, "touchmove", this._delayedDragTouchMoveHandler), u(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(t, e) {
    e = e || "touch" == t.pointerType && t, !this.nativeDraggable || e ? c(document, this.options.supportPointer ? "pointermove" : e ? "touchmove" : "mousemove", this._onTouchMove) : (c(L, "dragend", this), c(j, "dragstart", this._onDragStart));

    try {
      document.selection ? Yt(function () {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch (t) {}
  },
  _dragStarted: function _dragStarted(t, e) {
    if (ht = !1, j && L) {
      H("dragStarted", this, {
        evt: e
      }), this.nativeDraggable && c(document, "dragover", At);
      var n = this.options;
      !t && v(L, n.dragClass, !1), v(L, n.ghostClass, !0), It.active = this, t && this._appendGhost(), F({
        sortable: this,
        name: "start",
        originalEvent: e
      });
    } else this._nulling();
  },
  _emulateDragOver: function _emulateDragOver() {
    if (nt) {
      this._lastX = nt.clientX, this._lastY = nt.clientY, xt();

      for (var t = document.elementFromPoint(nt.clientX, nt.clientY), e = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(nt.clientX, nt.clientY)) !== e;) {
        e = t;
      }

      if (L.parentNode[k]._isOutsideThisEl(t), e) do {
        if (e[k] && e[k]._onDragOver({
          clientX: nt.clientX,
          clientY: nt.clientY,
          target: t,
          rootEl: e
        }) && !this.options.dragoverBubble) break;
        t = e;
      } while (e = e.parentNode);
      Mt();
    }
  },
  _onTouchMove: function _onTouchMove(t) {
    if (et) {
      var e = this.options,
          n = e.fallbackTolerance,
          o = e.fallbackOffset,
          i = t.touches ? t.touches[0] : t,
          r = W && b(W, !0),
          a = W && r && r.a,
          l = W && r && r.d,
          s = yt && dt && T(dt),
          c = (i.clientX - et.clientX + o.x) / (a || 1) + (s ? s[0] - mt[0] : 0) / (a || 1),
          u = (i.clientY - et.clientY + o.y) / (l || 1) + (s ? s[1] - mt[1] : 0) / (l || 1);

      if (!It.active && !ht) {
        if (n && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < n) return;

        this._onDragStart(t, !0);
      }

      if (W) {
        r ? (r.e += c - (ot || 0), r.f += u - (it || 0)) : r = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: c,
          f: u
        };
        var d = "matrix(" + r.a + "," + r.b + "," + r.c + "," + r.d + "," + r.e + "," + r.f + ")";
        m(W, "webkitTransform", d), m(W, "mozTransform", d), m(W, "msTransform", d), m(W, "transform", d), ot = c, it = u, nt = i;
      }

      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!W) {
      var t = this.options.fallbackOnBody ? document.body : j,
          e = y(L, !0, yt, !0, t),
          n = this.options;

      if (yt) {
        for (dt = t; "static" === m(dt, "position") && "none" === m(dt, "transform") && dt !== document;) {
          dt = dt.parentNode;
        }

        dt !== document.body && dt !== document.documentElement ? (dt === document && (dt = E()), e.top += dt.scrollTop, e.left += dt.scrollLeft) : dt = E(), mt = T(dt);
      }

      v(W = L.cloneNode(!0), n.ghostClass, !1), v(W, n.fallbackClass, !0), v(W, n.dragClass, !0), m(W, "transition", ""), m(W, "transform", ""), m(W, "box-sizing", "border-box"), m(W, "margin", 0), m(W, "top", e.top), m(W, "left", e.left), m(W, "width", e.width), m(W, "height", e.height), m(W, "opacity", "0.8"), m(W, "position", yt ? "absolute" : "fixed"), m(W, "zIndex", "100000"), m(W, "pointerEvents", "none"), It.ghost = W, t.appendChild(W), m(W, "transform-origin", rt / parseInt(W.style.width) * 100 + "% " + at / parseInt(W.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(t, e) {
    var n = this,
        o = t.dataTransfer,
        i = n.options;
    H("dragStart", this, {
      evt: t
    }), It.eventCanceled ? this._onDrop() : (H("setupClone", this), It.eventCanceled || ((U = A(L)).draggable = !1, U.style["will-change"] = "", this._hideClone(), v(U, this.options.chosenClass, !1), It.clone = U), n.cloneId = Yt(function () {
      H("clone", n), It.eventCanceled || (n.options.removeCloneOnHide || j.insertBefore(U, L), n._hideClone(), F({
        sortable: n,
        name: "clone"
      }));
    }), !e && v(L, i.dragClass, !0), e ? (ft = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (u(document, "mouseup", n._onDrop), u(document, "touchend", n._onDrop), u(document, "touchcancel", n._onDrop), o && (o.effectAllowed = "move", i.setData && i.setData.call(n, o, L)), c(document, "drop", n), m(L, "transform", "translateZ(0)")), ht = !0, n._dragStartId = Yt(n._dragStarted.bind(n, e, t)), c(document, "selectstart", n), lt = !0, r && m(document.body, "user-select", "none"));
  },
  _onDragOver: function _onDragOver(e) {
    var n,
        o,
        i,
        r,
        a = this.el,
        l = e.target,
        s = this.options,
        c = s.group,
        u = It.active,
        d = J === c,
        h = s.sort,
        p = tt || u,
        g = this,
        b = !1;

    if (!bt) {
      if (void 0 !== e.preventDefault && e.cancelable && e.preventDefault(), l = f(l, s.draggable, a, !0), B("dragOver"), It.eventCanceled) return b;
      if (L.contains(e.target) || l.animated && l.animatingX && l.animatingY || g._ignoreWhileAnimating === l) return U(!1);

      if (ft = !1, u && !s.disabled && (d ? h || (i = !j.contains(L)) : tt === this || (this.lastPutMode = J.checkPull(this, u, L, e)) && c.checkPut(this, u, L, e))) {
        if (r = "vertical" === this._getDirection(e, l), n = y(L), B("dragOverValid"), It.eventCanceled) return b;
        if (i) return K = j, G(), this._hideClone(), B("revert"), It.eventCanceled || (z ? j.insertBefore(L, z) : j.appendChild(L)), U(!0);
        var w = S(a, s.draggable);

        if (!w || function (t, e, n) {
          var o = y(S(n.el, n.options.draggable));
          return e ? t.clientX > o.right + 10 || t.clientX <= o.right && t.clientY > o.bottom && t.clientX >= o.left : t.clientX > o.right && t.clientY > o.top || t.clientX <= o.right && t.clientY > o.bottom + 10;
        }(e, r, this) && !w.animated) {
          if (w === L) return U(!1);
          if (w && a === e.target && (l = w), l && (o = y(l)), !1 !== Pt(j, a, L, n, l, o, e, !!l)) return G(), a.appendChild(L), K = a, q(), U(!0);
        } else if (l.parentNode === a) {
          o = y(l);

          var E,
              _,
              T,
              x = L.parentNode !== a,
              M = !function (t, e, n) {
            var o = n ? t.left : t.top,
                i = n ? e.left : e.top;
            return o === i || (n ? t.right : t.bottom) === (n ? e.right : e.bottom) || o + (n ? t.width : t.height) / 2 === i + (n ? e.width : e.height) / 2;
          }(L.animated && L.toRect || n, l.animated && l.toRect || o, r),
              N = r ? "top" : "left",
              A = D(l, "top", "top") || D(L, "top", "top"),
              I = A ? A.scrollTop : void 0;

          if (st !== l && (_ = o[N], gt = !1, vt = !M && s.invertSwap || x), 0 !== (E = function (t, e, n, o, i, r, a, l) {
            var s = o ? t.clientY : t.clientX,
                c = o ? n.height : n.width,
                u = o ? n.top : n.left,
                d = o ? n.bottom : n.right,
                h = !1;
            if (!a) if (l && ut < c * i) {
              if (!gt && (1 === ct ? s > u + c * r / 2 : s < d - c * r / 2) && (gt = !0), gt) h = !0;else if (1 === ct ? s < u + ut : s > d - ut) return -ct;
            } else if (s > u + c * (1 - i) / 2 && s < d - c * (1 - i) / 2) return function (t) {
              return C(L) < C(t) ? 1 : -1;
            }(e);
            return (h = h || a) && (s < u + c * r / 2 || s > d - c * r / 2) ? s > u + c / 2 ? 1 : -1 : 0;
          }(e, l, o, r, M ? 1 : s.swapThreshold, null == s.invertedSwapThreshold ? s.swapThreshold : s.invertedSwapThreshold, vt, st === l))) {
            var P = C(L);

            do {
              T = K.children[P -= E];
            } while (T && ("none" === m(T, "display") || T === W));
          }

          if (0 === E || T === l) return U(!1);
          st = l, ct = E;
          var R = l.nextElementSibling,
              X = !1,
              Y = Pt(j, a, L, n, l, o, e, X = 1 === E);
          if (!1 !== Y) return 1 !== Y && -1 !== Y || (X = 1 === Y), bt = !0, setTimeout(Rt, 30), G(), X && !R ? a.appendChild(L) : l.parentNode.insertBefore(L, X ? R : l), A && O(A, 0, I - A.scrollTop), K = L.parentNode, void 0 === _ || vt || (ut = Math.abs(_ - y(l)[N])), q(), U(!0);
        }

        if (a.contains(L)) return U(!1);
      }

      return !1;
    }

    function B(s, c) {
      H(s, g, t({
        evt: e,
        isOwner: d,
        axis: r ? "vertical" : "horizontal",
        revert: i,
        dragRect: n,
        targetRect: o,
        canSort: h,
        fromSortable: p,
        target: l,
        completed: U,
        onMove: function onMove(t, o) {
          return Pt(j, a, L, n, t, y(t), e, o);
        },
        changed: q
      }, c));
    }

    function G() {
      B("dragOverAnimationCapture"), g.captureAnimationState(), g !== p && p.captureAnimationState();
    }

    function U(t) {
      return B("dragOverCompleted", {
        insertion: t
      }), t && (d ? u._hideClone() : u._showClone(g), g !== p && (v(L, tt ? tt.options.ghostClass : u.options.ghostClass, !1), v(L, s.ghostClass, !0)), tt !== g && g !== It.active ? tt = g : g === It.active && tt && (tt = null), p === g && (g._ignoreWhileAnimating = l), g.animateAll(function () {
        B("dragOverAnimationComplete"), g._ignoreWhileAnimating = null;
      }), g !== p && (p.animateAll(), p._ignoreWhileAnimating = null)), (l === L && !L.animated || l === a && !l.animated) && (st = null), s.dragoverBubble || e.rootEl || l === document || (L.parentNode[k]._isOutsideThisEl(e.target), !t && Ot(e)), !s.dragoverBubble && e.stopPropagation && e.stopPropagation(), b = !0;
    }

    function q() {
      Z = C(L), $ = C(L, s.draggable), F({
        sortable: g,
        name: "change",
        toEl: a,
        newIndex: Z,
        newDraggableIndex: $,
        originalEvent: e
      });
    }
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    u(document, "mousemove", this._onTouchMove), u(document, "touchmove", this._onTouchMove), u(document, "pointermove", this._onTouchMove), u(document, "dragover", Ot), u(document, "mousemove", Ot), u(document, "touchmove", Ot);
  },
  _offUpEvents: function _offUpEvents() {
    var t = this.el.ownerDocument;
    u(t, "mouseup", this._onDrop), u(t, "touchend", this._onDrop), u(t, "pointerup", this._onDrop), u(t, "touchcancel", this._onDrop), u(document, "selectstart", this);
  },
  _onDrop: function _onDrop(t) {
    var e = this.el,
        n = this.options;
    Z = C(L), $ = C(L, n.draggable), H("drop", this, {
      evt: t
    }), K = L && L.parentNode, Z = C(L), $ = C(L, n.draggable), It.eventCanceled || (ht = !1, vt = !1, gt = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Bt(this.cloneId), Bt(this._dragStartId), this.nativeDraggable && (u(document, "drop", this), u(e, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), r && m(document.body, "user-select", ""), m(L, "transform", ""), t && (lt && (t.cancelable && t.preventDefault(), !n.dropBubble && t.stopPropagation()), W && W.parentNode && W.parentNode.removeChild(W), (j === K || tt && "clone" !== tt.lastPutMode) && U && U.parentNode && U.parentNode.removeChild(U), L && (this.nativeDraggable && u(L, "dragend", this), kt(L), L.style["will-change"] = "", lt && !ht && v(L, tt ? tt.options.ghostClass : this.options.ghostClass, !1), v(L, this.options.chosenClass, !1), F({
      sortable: this,
      name: "unchoose",
      toEl: K,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), j !== K ? (Z >= 0 && (F({
      rootEl: K,
      name: "add",
      toEl: K,
      fromEl: j,
      originalEvent: t
    }), F({
      sortable: this,
      name: "remove",
      toEl: K,
      originalEvent: t
    }), F({
      rootEl: K,
      name: "sort",
      toEl: K,
      fromEl: j,
      originalEvent: t
    }), F({
      sortable: this,
      name: "sort",
      toEl: K,
      originalEvent: t
    })), tt && tt.save()) : Z !== V && Z >= 0 && (F({
      sortable: this,
      name: "update",
      toEl: K,
      originalEvent: t
    }), F({
      sortable: this,
      name: "sort",
      toEl: K,
      originalEvent: t
    })), It.active && (null != Z && -1 !== Z || (Z = V, $ = Q), F({
      sortable: this,
      name: "end",
      toEl: K,
      originalEvent: t
    }), this.save())))), this._nulling();
  },
  _nulling: function _nulling() {
    H("nulling", this), j = L = K = W = z = U = G = q = et = nt = lt = Z = $ = V = Q = st = ct = tt = J = It.dragged = It.ghost = It.clone = It.active = null, wt.forEach(function (t) {
      t.checked = !0;
    }), wt.length = ot = it = 0;
  },
  handleEvent: function handleEvent(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);

        break;

      case "dragenter":
      case "dragover":
        L && (this._onDragOver(t), function (t) {
          t.dataTransfer && (t.dataTransfer.dropEffect = "move"), t.cancelable && t.preventDefault();
        }(t));
        break;

      case "selectstart":
        t.preventDefault();
    }
  },
  toArray: function toArray() {
    for (var t, e = [], n = this.el.children, o = 0, i = n.length, r = this.options; o < i; o++) {
      f(t = n[o], r.draggable, this.el, !1) && e.push(t.getAttribute(r.dataIdAttr) || Xt(t));
    }

    return e;
  },
  sort: function sort(t) {
    var e = {},
        n = this.el;
    this.toArray().forEach(function (t, o) {
      var i = n.children[o];
      f(i, this.options.draggable, n, !1) && (e[t] = i);
    }, this), t.forEach(function (t) {
      e[t] && (n.removeChild(e[t]), n.appendChild(e[t]));
    });
  },
  save: function save() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  closest: function closest(t, e) {
    return f(t, e || this.options.draggable, this.el, !1);
  },
  option: function option(t, e) {
    var n = this.options;
    if (void 0 === e) return n[t];
    var o = Y.modifyOption(this, t, e);
    n[t] = void 0 !== o ? o : e, "group" === t && Tt(n);
  },
  destroy: function destroy() {
    H("destroy", this);
    var t = this.el;
    t[k] = null, u(t, "mousedown", this._onTapStart), u(t, "touchstart", this._onTapStart), u(t, "pointerdown", this._onTapStart), this.nativeDraggable && (u(t, "dragover", this), u(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function (t) {
      t.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), pt.splice(pt.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function _hideClone() {
    if (!q) {
      if (H("hideClone", this), It.eventCanceled) return;
      m(U, "display", "none"), this.options.removeCloneOnHide && U.parentNode && U.parentNode.removeChild(U), q = !0;
    }
  },
  _showClone: function _showClone(t) {
    if ("clone" === t.lastPutMode) {
      if (q) {
        if (H("showClone", this), It.eventCanceled) return;
        L.parentNode != j || this.options.group.revertClone ? z ? j.insertBefore(U, z) : j.appendChild(U) : j.insertBefore(U, L), this.options.group.revertClone && this.animate(L, U), m(U, "display", ""), q = !1;
      }
    } else this._hideClone();
  }
}, Et && c(document, "touchmove", function (t) {
  (It.active || ht) && t.cancelable && t.preventDefault();
}), It.utils = {
  on: c,
  off: u,
  css: m,
  find: w,
  is: function is(t, e) {
    return !!f(t, e, t, !1);
  },
  extend: function extend(t, e) {
    if (t && e) for (var n in e) {
      e.hasOwnProperty(n) && (t[n] = e[n]);
    }
    return t;
  },
  throttle: N,
  closest: f,
  toggleClass: v,
  clone: A,
  index: C,
  nextTick: Yt,
  cancelNextTick: Bt,
  detectDirection: Ct,
  getChild: _
}, It.get = function (t) {
  return t[k];
}, It.mount = function () {
  var e = [].slice.call(arguments);
  e[0].constructor === Array && (e = e[0]), e.forEach(function (e) {
    if (!e.prototype || !e.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not " + {}.toString.call(e);
    e.utils && (It.utils = t({}, It.utils, e.utils)), Y.mount(e);
  });
}, It.create = function (t, e) {
  return new It(t, e);
}, It.version = "1.12.0";
var Ht,
    Ft,
    Lt,
    Kt,
    Wt,
    jt = [],
    zt = [],
    Gt = !1,
    Ut = !1,
    qt = !1;

function Vt(t, e) {
  zt.forEach(function (n, o) {
    var i = e.children[n.sortableIndex + (t ? Number(o) : 0)];
    i ? e.insertBefore(n, i) : e.appendChild(n);
  });
}

function Zt() {
  jt.forEach(function (t) {
    t !== Lt && t.parentNode && t.parentNode.removeChild(t);
  });
}

var Qt = function Qt(t) {
  var e = t.originalEvent,
      n = t.putSortable,
      o = t.dragEl,
      i = t.dispatchSortableEvent,
      r = t.unhideGhostForTarget;

  if (e) {
    var a = n || t.activeSortable;
    (0, t.hideGhostForTarget)();
    var l = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e,
        s = document.elementFromPoint(l.clientX, l.clientY);
    r(), a && !a.el.contains(s) && (i("spill"), this.onSpill({
      dragEl: o,
      putSortable: n
    }));
  }
};

function $t() {}

function Jt() {}

$t.prototype = {
  startIndex: null,
  dragStart: function dragStart(t) {
    this.startIndex = t.oldDraggableIndex;
  },
  onSpill: function onSpill(t) {
    var e = t.dragEl,
        n = t.putSortable;
    this.sortable.captureAnimationState(), n && n.captureAnimationState();

    var o = _(this.sortable.el, this.startIndex, this.options);

    o ? this.sortable.el.insertBefore(e, o) : this.sortable.el.appendChild(e), this.sortable.animateAll(), n && n.animateAll();
  },
  drop: Qt
}, Object.assign($t, {
  pluginName: "revertOnSpill"
}), Jt.prototype = {
  onSpill: function onSpill(t) {
    var e = t.dragEl,
        n = t.putSortable || this.sortable;
    n.captureAnimationState(), e.parentNode && e.parentNode.removeChild(e), n.animateAll();
  },
  drop: Qt
}, Object.assign(Jt, {
  pluginName: "removeOnSpill"
});
var te,
    ee,
    ne,
    oe,
    ie,
    re,
    ae = [],
    le = !1;

function se() {
  ae.forEach(function (t) {
    clearInterval(t.pid);
  }), ae = [];
}

function ce() {
  clearInterval(re);
}

var ue = N(function (t, e, n, o) {
  if (e.scroll) {
    var i,
        r = (t.touches ? t.touches[0] : t).clientX,
        a = (t.touches ? t.touches[0] : t).clientY,
        l = e.scrollSensitivity,
        s = e.scrollSpeed,
        c = E(),
        u = !1;
    ee !== n && (ee = n, se(), i = e.scrollFn, !0 === (te = e.scroll) && (te = x(n, !0)));
    var d = 0,
        h = te;

    do {
      var f = h,
          p = y(f),
          g = p.top,
          v = p.bottom,
          b = p.left,
          w = p.right,
          D = p.width,
          _ = p.height,
          S = void 0,
          C = void 0,
          T = f.scrollWidth,
          M = f.scrollHeight,
          N = m(f),
          A = f.scrollLeft,
          I = f.scrollTop;
      f === c ? (S = D < T && ("auto" === N.overflowX || "scroll" === N.overflowX || "visible" === N.overflowX), C = _ < M && ("auto" === N.overflowY || "scroll" === N.overflowY || "visible" === N.overflowY)) : (S = D < T && ("auto" === N.overflowX || "scroll" === N.overflowX), C = _ < M && ("auto" === N.overflowY || "scroll" === N.overflowY));
      var P = S && (Math.abs(w - r) <= l && A + D < T) - (Math.abs(b - r) <= l && !!A),
          R = C && (Math.abs(v - a) <= l && I + _ < M) - (Math.abs(g - a) <= l && !!I);
      if (!ae[d]) for (var X = 0; X <= d; X++) {
        ae[X] || (ae[X] = {});
      }
      ae[d].vx == P && ae[d].vy == R && ae[d].el === f || (ae[d].el = f, ae[d].vx = P, ae[d].vy = R, clearInterval(ae[d].pid), 0 == P && 0 == R || (u = !0, ae[d].pid = setInterval(function () {
        o && 0 === this.layer && It.active._onTouchMove(ie);
        var e = ae[this.layer].vy ? ae[this.layer].vy * s : 0,
            n = ae[this.layer].vx ? ae[this.layer].vx * s : 0;
        "function" == typeof i && "continue" !== i.call(It.dragged.parentNode[k], n, e, t, ie, ae[this.layer].el) || O(ae[this.layer].el, n, e);
      }.bind({
        layer: d
      }), 24))), d++;
    } while (e.bubbleScroll && h !== c && (h = x(h, !1)));

    le = u;
  }
}, 30);
It.mount(new function () {
  function t() {
    for (var t in this.defaults = {
      scroll: !0,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    }, this) {
      "_" === t.charAt(0) && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
  }

  return t.prototype = {
    dragStarted: function dragStarted(t) {
      var e = t.originalEvent;
      this.sortable.nativeDraggable ? c(document, "dragover", this._handleAutoScroll) : c(document, this.options.supportPointer ? "pointermove" : e.touches ? "touchmove" : "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function dragOverCompleted(t) {
      var e = t.originalEvent;
      this.options.dragOverBubble || e.rootEl || this._handleAutoScroll(e);
    },
    drop: function drop() {
      this.sortable.nativeDraggable ? u(document, "dragover", this._handleAutoScroll) : (u(document, "pointermove", this._handleFallbackAutoScroll), u(document, "touchmove", this._handleFallbackAutoScroll), u(document, "mousemove", this._handleFallbackAutoScroll)), ce(), se(), clearTimeout(p), p = void 0;
    },
    nulling: function nulling() {
      ie = ee = te = le = re = ne = oe = null, ae.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(t) {
      this._handleAutoScroll(t, !0);
    },
    _handleAutoScroll: function _handleAutoScroll(t, e) {
      var i = this,
          a = (t.touches ? t.touches[0] : t).clientX,
          l = (t.touches ? t.touches[0] : t).clientY,
          s = document.elementFromPoint(a, l);

      if (ie = t, e || o || n || r) {
        ue(t, this.options, s, e);
        var c = x(s, !0);
        !le || re && a === ne && l === oe || (re && ce(), re = setInterval(function () {
          var n = x(document.elementFromPoint(a, l), !0);
          n !== c && (c = n, se()), ue(t, i.options, n, e);
        }, 10), ne = a, oe = l);
      } else {
        if (!this.options.bubbleScroll || x(s, !0) === E()) return void se();
        ue(t, this.options, x(s, !1), !1);
      }
    }
  }, Object.assign(t, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}()), It.mount(Jt, $t), It.mount(new function () {
  function t() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }

  return t.prototype = {
    dragStart: function dragStart(t) {
      Nt = t.dragEl;
    },
    dragOverValid: function dragOverValid(t) {
      var e = t.completed,
          n = t.target,
          o = t.changed,
          i = t.cancel;

      if (t.activeSortable.options.swap) {
        var r = this.options;

        if (n && n !== this.sortable.el) {
          var a = Nt;
          !1 !== (0, t.onMove)(n) ? (v(n, r.swapClass, !0), Nt = n) : Nt = null, a && a !== Nt && v(a, r.swapClass, !1);
        }

        o(), e(!0), i();
      }
    },
    drop: function drop(t) {
      var e,
          n,
          o,
          i,
          r,
          a,
          l = t.activeSortable,
          s = t.putSortable,
          c = t.dragEl,
          u = s || this.sortable,
          d = this.options;
      Nt && v(Nt, d.swapClass, !1), Nt && (d.swap || s && s.options.swap) && c !== Nt && (u.captureAnimationState(), u !== l && l.captureAnimationState(), a = (n = Nt).parentNode, (r = (e = c).parentNode) && a && !r.isEqualNode(n) && !a.isEqualNode(e) && (o = C(e), i = C(n), r.isEqualNode(a) && o < i && i++, r.insertBefore(n, r.children[o]), a.insertBefore(e, a.children[i])), u.animateAll(), u !== l && l.animateAll());
    },
    nulling: function nulling() {
      Nt = null;
    }
  }, Object.assign(t, {
    pluginName: "swap",
    eventProperties: function eventProperties() {
      return {
        swapItem: Nt
      };
    }
  });
}()), It.mount(new function () {
  function t(t) {
    for (var e in this) {
      "_" === e.charAt(0) && "function" == typeof this[e] && (this[e] = this[e].bind(this));
    }

    t.options.supportPointer ? c(document, "pointerup", this._deselectMultiDrag) : (c(document, "mouseup", this._deselectMultiDrag), c(document, "touchend", this._deselectMultiDrag)), c(document, "keydown", this._checkKeyDown), c(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      setData: function setData(e, n) {
        var o = "";
        jt.length && Ft === t ? jt.forEach(function (t, e) {
          o += (e ? ", " : "") + t.textContent;
        }) : o = n.textContent, e.setData("Text", o);
      }
    };
  }

  return t.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function delayStartGlobal(t) {
      Lt = t.dragEl;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~jt.indexOf(Lt);
    },
    setupClone: function setupClone(t) {
      var e = t.sortable,
          n = t.cancel;

      if (this.isMultiDrag) {
        for (var o = 0; o < jt.length; o++) {
          zt.push(A(jt[o])), zt[o].sortableIndex = jt[o].sortableIndex, zt[o].draggable = !1, zt[o].style["will-change"] = "", v(zt[o], this.options.selectedClass, !1), jt[o] === Lt && v(zt[o], this.options.chosenClass, !1);
        }

        e._hideClone(), n();
      }
    },
    clone: function clone(t) {
      var e = t.dispatchSortableEvent,
          n = t.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || jt.length && Ft === t.sortable && (Vt(!0, t.rootEl), e("clone"), n()));
    },
    showClone: function showClone(t) {
      var e = t.cloneNowShown,
          n = t.cancel;
      this.isMultiDrag && (Vt(!1, t.rootEl), zt.forEach(function (t) {
        m(t, "display", "");
      }), e(), Wt = !1, n());
    },
    hideClone: function hideClone(t) {
      var e = this,
          n = t.cloneNowHidden,
          o = t.cancel;
      this.isMultiDrag && (zt.forEach(function (t) {
        m(t, "display", "none"), e.options.removeCloneOnHide && t.parentNode && t.parentNode.removeChild(t);
      }), n(), Wt = !0, o());
    },
    dragStartGlobal: function dragStartGlobal(t) {
      !this.isMultiDrag && Ft && Ft.multiDrag._deselectMultiDrag(), jt.forEach(function (t) {
        t.sortableIndex = C(t);
      }), jt = jt.sort(function (t, e) {
        return t.sortableIndex - e.sortableIndex;
      }), qt = !0;
    },
    dragStarted: function dragStarted(t) {
      var e = this,
          n = t.sortable;

      if (this.isMultiDrag) {
        if (this.options.sort && (n.captureAnimationState(), this.options.animation)) {
          jt.forEach(function (t) {
            t !== Lt && m(t, "position", "absolute");
          });
          var o = y(Lt, !1, !0, !0);
          jt.forEach(function (t) {
            t !== Lt && I(t, o);
          }), Ut = !0, Gt = !0;
        }

        n.animateAll(function () {
          Ut = !1, Gt = !1, e.options.animation && jt.forEach(function (t) {
            P(t);
          }), e.options.sort && Zt();
        });
      }
    },
    dragOver: function dragOver(t) {
      var e = t.completed,
          n = t.cancel;
      Ut && ~jt.indexOf(t.target) && (e(!1), n());
    },
    revert: function revert(t) {
      var e = t.fromSortable,
          n = t.rootEl,
          o = t.sortable,
          i = t.dragRect;
      jt.length > 1 && (jt.forEach(function (t) {
        o.addAnimationState({
          target: t,
          rect: Ut ? y(t) : i
        }), P(t), t.fromRect = i, e.removeAnimationState(t);
      }), Ut = !1, function (t, e) {
        jt.forEach(function (n, o) {
          var i = e.children[n.sortableIndex + (t ? Number(o) : 0)];
          i ? e.insertBefore(n, i) : e.appendChild(n);
        });
      }(!this.options.removeCloneOnHide, n));
    },
    dragOverCompleted: function dragOverCompleted(t) {
      var e = t.sortable,
          n = t.isOwner,
          o = t.activeSortable,
          i = t.parentEl,
          r = t.putSortable,
          a = this.options;

      if (t.insertion) {
        if (n && o._hideClone(), Gt = !1, a.animation && jt.length > 1 && (Ut || !n && !o.options.sort && !r)) {
          var l = y(Lt, !1, !0, !0);
          jt.forEach(function (t) {
            t !== Lt && (I(t, l), i.appendChild(t));
          }), Ut = !0;
        }

        if (!n) if (Ut || Zt(), jt.length > 1) {
          var s = Wt;
          o._showClone(e), o.options.animation && !Wt && s && zt.forEach(function (t) {
            o.addAnimationState({
              target: t,
              rect: Kt
            }), t.fromRect = Kt, t.thisAnimationDuration = null;
          });
        } else o._showClone(e);
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(t) {
      var e = t.dragRect,
          n = t.isOwner,
          o = t.activeSortable;

      if (jt.forEach(function (t) {
        t.thisAnimationDuration = null;
      }), o.options.animation && !n && o.multiDrag.isMultiDrag) {
        Kt = Object.assign({}, e);
        var i = b(Lt, !0);
        Kt.top -= i.f, Kt.left -= i.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      Ut && (Ut = !1, Zt());
    },
    drop: function drop(t) {
      var e = t.originalEvent,
          n = t.rootEl,
          o = t.parentEl,
          i = t.sortable,
          r = t.dispatchSortableEvent,
          a = t.oldIndex,
          l = t.putSortable,
          s = l || this.sortable;

      if (e) {
        var c = this.options,
            u = o.children;
        if (!qt) if (c.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), v(Lt, c.selectedClass, !~jt.indexOf(Lt)), ~jt.indexOf(Lt)) jt.splice(jt.indexOf(Lt), 1), Ht = null, B({
          sortable: i,
          rootEl: n,
          name: "deselect",
          targetEl: Lt,
          originalEvt: e
        });else {
          if (jt.push(Lt), B({
            sortable: i,
            rootEl: n,
            name: "select",
            targetEl: Lt,
            originalEvt: e
          }), e.shiftKey && Ht && i.el.contains(Ht)) {
            var d,
                h,
                f = C(Ht),
                p = C(Lt);
            if (~f && ~p && f !== p) for (p > f ? (h = f, d = p) : (h = p, d = f + 1); h < d; h++) {
              ~jt.indexOf(u[h]) || (v(u[h], c.selectedClass, !0), jt.push(u[h]), B({
                sortable: i,
                rootEl: n,
                name: "select",
                targetEl: u[h],
                originalEvt: e
              }));
            }
          } else Ht = Lt;

          Ft = s;
        }

        if (qt && this.isMultiDrag) {
          if ((o[k].options.sort || o !== n) && jt.length > 1) {
            var g = y(Lt),
                m = C(Lt, ":not(." + this.options.selectedClass + ")");

            if (!Gt && c.animation && (Lt.thisAnimationDuration = null), s.captureAnimationState(), !Gt && (c.animation && (Lt.fromRect = g, jt.forEach(function (t) {
              if (t.thisAnimationDuration = null, t !== Lt) {
                var e = Ut ? y(t) : g;
                t.fromRect = e, s.addAnimationState({
                  target: t,
                  rect: e
                });
              }
            })), Zt(), jt.forEach(function (t) {
              u[m] ? o.insertBefore(t, u[m]) : o.appendChild(t), m++;
            }), a === C(Lt))) {
              var b = !1;
              jt.forEach(function (t) {
                t.sortableIndex === C(t) || (b = !0);
              }), b && r("update");
            }

            jt.forEach(function (t) {
              P(t);
            }), s.animateAll();
          }

          Ft = s;
        }

        (n === o || l && "clone" !== l.lastPutMode) && zt.forEach(function (t) {
          t.parentNode && t.parentNode.removeChild(t);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = qt = !1, zt.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag(), u(document, "pointerup", this._deselectMultiDrag), u(document, "mouseup", this._deselectMultiDrag), u(document, "touchend", this._deselectMultiDrag), u(document, "keydown", this._checkKeyDown), u(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(t) {
      if (!(void 0 !== qt && qt || Ft !== this.sortable || t && f(t.target, this.options.draggable, this.sortable.el, !1) || t && 0 !== t.button)) for (; jt.length;) {
        var e = jt[0];
        v(e, this.options.selectedClass, !1), jt.shift(), B({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: "deselect",
          targetEl: e,
          originalEvt: t
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(t) {
      t.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function _checkKeyUp(t) {
      t.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, Object.assign(t, {
    pluginName: "multiDrag",
    utils: {
      select: function select(t) {
        var e = t.parentNode[k];
        e && e.options.multiDrag && !~jt.indexOf(t) && (Ft && Ft !== e && (Ft.multiDrag._deselectMultiDrag(), Ft = e), v(t, e.options.selectedClass, !0), jt.push(t));
      },
      deselect: function deselect(t) {
        var e = t.parentNode[k],
            n = jt.indexOf(t);
        e && e.options.multiDrag && ~n && (v(t, e.options.selectedClass, !1), jt.splice(n, 1));
      }
    },
    eventProperties: function eventProperties() {
      var t = this,
          e = [],
          n = [];
      return jt.forEach(function (o) {
        var i;
        e.push({
          multiDragElement: o,
          index: o.sortableIndex
        }), i = Ut && o !== Lt ? -1 : Ut ? C(o, ":not(." + t.options.selectedClass + ")") : C(o), n.push({
          multiDragElement: o,
          index: i
        });
      }), {
        items: [].concat(jt),
        clones: [].concat(zt),
        oldIndicies: e,
        newIndicies: n
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(t) {
        return "ctrl" === (t = t.toLowerCase()) ? t = "Control" : t.length > 1 && (t = t.charAt(0).toUpperCase() + t.substr(1)), t;
      }
    }
  });
}());
export default It;
export { It as Sortable };